(()=>{
  'use strict';
  const API = window.wpApiSettings ? window.wpApiSettings.root : '/wp-json/';
  async function checkDate(dateStr){
    try{
      const res = await fetch(`${API}photography-business/v1/availability?date=${encodeURIComponent(dateStr)}`);
      if(!res.ok) return { available:false };
      return await res.json();
    }catch(e){ return { available:false, error:true }; }
  }
  async function fetchBooked(year, month){
    try{
      const res = await fetch(`${API}photography-business/v1/booked-dates?year=${year}&month=${month}`);
      if(!res.ok) return { booked: [] };
      return await res.json();
    }catch(e){ return { booked: [], error:true } }
  }
  window.PBBooking = { checkDate, fetchBooked };
})();
